import AchievementsPageInit from './AchievementsPageInit';
import ShareAction from '../../../../utils/ShareAction';

AchievementsPageInit.init();

// Utils
ShareAction.init();
